export const STORE_STORAGE_KEY = 'store'

// 2026-10-05：刷新仍沿用 sessionStorage 的 store 格式，不迁移到跨页面长期存储。
// 读取被微信暂时拒绝时仅返回空状态，不删除原记录；例如 SecurityError 不能被当作退出登录。
export function readSavedStore() {
  let storeText
  try {
    storeText = sessionStorage.getItem(STORE_STORAGE_KEY)
  } catch (error) {
    console.warn('无法读取登录记录，保留已有缓存并进入登录页')
    return null
  }
  if (!storeText) {
    return null
  }

  try {
    const savedStore = JSON.parse(storeText)
    if (savedStore && typeof savedStore === 'object' && !Array.isArray(savedStore)) {
      return savedStore
    }
    console.warn('登录记录格式异常，将进入登录页')
  } catch (e) {
    console.warn('登录记录无法解析，将进入登录页')
  }
  clearSavedStore()
  return null
}

// 2026-10-05：登录成功立即保存，不依赖 iOS 不一定触发的 beforeunload。
// 存储写入失败时保留当前内存登录，不能让登录流程或页面刷新因异常中断。
export function saveStoreState(state) {
  try {
    sessionStorage.setItem(STORE_STORAGE_KEY, JSON.stringify(state))
    return true
  } catch (error) {
    console.warn('无法保存登录记录，刷新后可能需要重新登录')
    return false
  }
}

// 2026-10-05：只删除当前登录记录，保留记住的账号和换卡输入；删除失败也不能阻止退出界面。
export function clearSavedStore() {
  try {
    sessionStorage.removeItem(STORE_STORAGE_KEY)
    return true
  } catch (error) {
    console.warn('无法清理登录记录，请关闭当前网页后重新进入')
    return false
  }
}
